import { NgModule } from '@angular/core';
import { AppMoneyPipe } from './app-money.pipe';

@NgModule({
  declarations: [AppMoneyPipe],
  exports: [AppMoneyPipe]
})
export class AppMoneyPipeModule {}
